import React, { Component } from "react";
import "./App.css";
import setBrandStyles from "./setBrandStyles";
import EnterPhoneNumber from "./EnterPhoneNumber";
import EnterVerifyCode from "./EnterVerifyCode";
import Success from "./Success";
import Api from "./api";

const withTimeout = (ms: number, promise: Promise<any>) => {
  const timeout = new Promise((resolve, reject) => {
    setTimeout(() => {
      reject(new Error("Promise rejected due to timeout."));
    }, ms);
  });
  return Promise.race([timeout, promise]);
};

const Steps = {
  EnterPhoneNumber: "EnterPhoneNumber",
  EnterVerifyCode: "EnterVerifyCode",
  Success: "Success"
};

interface Shop {
  name: string;
  color: string;
  lightColor: string;
  tosUrl: string;
  policyUrl: string;
  optInPreference: string;
}

interface State {
  step: string;
  phoneNumber: string;
  acceptMarketing: boolean;
  open: boolean;
  userId: string;
  shop: Shop;
}

interface Props {
  domain: string;
}

class App extends Component<Props, State> {
  state = {
    step: Steps.EnterPhoneNumber,
    phoneNumber: "",
    acceptMarketing: true,
    open: false,
    userId: "",
    shop: {
      name: "",
      color: "",
      lightColor: "",
      optinSettings: {
        discountText: "",
        discountUrl: "",
        modal: {
          body: "",
          title: "",
        },
        page: {
          body: "",
          title: "",
        },
        termsOfService: "",
      },
      tosUrl: "",
      policyUrl: "",
      optInPreference: ""
    }
  };
  async componentDidMount() {
    const { domain } = this.props;
    const api = new Api(domain);

    withTimeout(6000, api.getEligibleForOptIn()).then(
      ({ isEligible, userId, shop, phone }) => {
        if (isEligible) {
          this.setState({ open: true, userId, shop, phoneNumber: phone });
        }
        setBrandStyles(shop);
      }
    );
    window.addEventListener("keyup", this.handleKeyUp, false);
  }
  componentWillUnmount() {
    window.removeEventListener("keyup", this.handleKeyUp, false);
  }
  handlePhoneNumberStepComplete = (
    phoneNumber: string,
    acceptMarketing: boolean
  ) => {
    this.setState({
      step: Steps.EnterVerifyCode,
      phoneNumber,
      acceptMarketing
    });
  };
  handleVerifyCodeStepComplete = () => {
    this.setState({
      step: Steps.Success
    });
  };
  handleKeyUp = (e: any) => {
    if (e.keyCode === 27) {
      e.preventDefault();
      this.handleClose();
      window.removeEventListener("keyup", this.handleKeyUp, false);
    }
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  renderBody = () => {
    const { step, phoneNumber, acceptMarketing, userId, shop } = this.state;
    const { domain } = this.props;

    const api = new Api(domain);

    switch (step) {
      case Steps.EnterPhoneNumber: {
        return (
          <EnterPhoneNumber
            onStepComplete={this.handlePhoneNumberStepComplete}
            userId={userId}
            phoneNumber={phoneNumber}
            sendVerifyCode={api.sendVerifyCode}
            shopName={shop.name}
            optinSettings={shop.optinSettings}
            tosUrl={shop.tosUrl}
            policyUrl={shop.policyUrl}
            color={shop.color}
            lightColor={shop.lightColor}
            optinMethod={shop.optInPreference}
          />
        );
      }
      case Steps.EnterVerifyCode: {
        return (
          <EnterVerifyCode
            phoneNumber={phoneNumber}
            acceptMarketing={acceptMarketing}
            onStepComplete={this.handleVerifyCodeStepComplete}
            userId={userId}
            submitVerifyCode={api.submitVerifyCode}
            color={shop.color}
            lightColor={shop.lightColor}
            optinMethod={shop.optInPreference}
          />
        );
      }
      case Steps.Success: {
        return (
          <Success
            onCloseClick={this.handleClose}
            color={shop.color}
            lightColor={shop.lightColor}
          />
        );
      }
    }
  };
  render() {
    if (!this.state.open) return null;

    if (this.state.shop.optInPreference === 'modal') {
      return (
        <div className="PRZM-ModalContainer" onClick={this.handleClose}>
          <div
            className="PRZM-Modal"
            onClick={(e: React.MouseEvent<HTMLElement>) => e.stopPropagation()}
          >
            <span className="CloseButton" onClick={this.handleClose}>
              &times;
            </span>
            <div className="PRZM-ModalBody">{this.renderBody()}</div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="section">
          <div className="content-box">
            <div className="PRZM-inline content-box__row">{this.renderBody()}</div>
          </div>
        </div>
      )
    }
  }
}

export default App;
